import Event from "../models/Event";
import {fetchEventsFromDatabase} from "./databasehandler";

export const getEvents = async () => {
    const result = await fetchEventsFromDatabase();

    if (result) {
        return result.map((event) => new Event(
            event.id,
            event.name,
            event.startDate,
            event.endDate,
            event.location,
            event.description,
            event.contact_email,
            event.race_type,
            event.registration_end
        ));
    }

    return null;
}